export default class Gallery {
  constructor(element) {
    this.element = element;
    this.filters = [...this.element.querySelectorAll('[data-gallery-filter]')];
    this.items = [...this.element.querySelectorAll('[data-gallery-item]')];
    this.hasPagination = this.element.hasAttribute('data-pagination');
    this.perPage = this.getPerPage();
    this.currentFilter = 'all';
    this.currentPage = 1;
    this.pagination = this.element.querySelector('[data-gallery-pagination]');

    if (!this.items.length) {
      return;
    }

    this.init();
  }

  init() {
    this.filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        this.currentFilter = filter.dataset.galleryFilter || 'all';
        this.currentPage = 1;
        this.render();
      });
    });

    if (this.hasPagination) {
      this.createPagination();
    }

    this.render();
  }

  getPerPage() {
    const value = Number.parseInt(this.element.dataset.nombrePerPage, 10);

    return Number.isFinite(value) && value > 0 ? value : this.items.length;
  }

  getFilteredItems() {
    return this.items.filter((item) => {
      const tags = (item.dataset.galleryItem || '').split(' ').filter(Boolean);

      return this.currentFilter === 'all' || tags.includes(this.currentFilter);
    });
  }

  createPagination() {
    if (this.pagination) {
      return;
    }

    this.pagination = document.createElement('nav');
    this.pagination.className = 'gallery__pagination';
    this.pagination.setAttribute('data-gallery-pagination', '');
    this.pagination.setAttribute('aria-label', 'Pagination de la galerie');
    this.element.querySelector('.gallery__grid')?.after(this.pagination);
  }

  render() {
    const filteredItems = this.getFilteredItems();
    const totalPages = this.hasPagination ? Math.max(1, Math.ceil(filteredItems.length / this.perPage)) : 1;

    if (this.currentPage > totalPages) {
      this.currentPage = totalPages;
    }

    this.filters.forEach((filter) => {
      filter.classList.toggle('is-active', (filter.dataset.galleryFilter || 'all') === this.currentFilter);
    });

    const start = (this.currentPage - 1) * this.perPage;
    const end = start + this.perPage;

    this.items.forEach((item) => {
      const filteredIndex = filteredItems.indexOf(item);
      const isFiltered = filteredIndex !== -1;
      const isOnPage = !this.hasPagination || (filteredIndex >= start && filteredIndex < end);
      const isVisible = isFiltered && isOnPage;

      item.classList.toggle('is-hidden', !isVisible);
      item.toggleAttribute('hidden', !isVisible);
    });

    this.renderPagination(totalPages);
  }

  renderPagination(totalPages) {
    if (!this.hasPagination || !this.pagination) {
      return;
    }

    this.pagination.innerHTML = '';
    this.pagination.hidden = totalPages <= 1;

    if (totalPages <= 1) {
      return;
    }

    this.pagination.appendChild(this.createPaginationButton('Prev', this.currentPage - 1, this.currentPage === 1));

    for (let page = 1; page <= totalPages; page += 1) {
      this.pagination.appendChild(this.createPaginationButton(page, page, false, page === this.currentPage));
    }

    this.pagination.appendChild(this.createPaginationButton('Next', this.currentPage + 1, this.currentPage === totalPages));
  }

  createPaginationButton(label, page, isDisabled = false, isActive = false) {
    const button = document.createElement('button');
    button.type = 'button';
    button.textContent = label;
    button.disabled = isDisabled;
    button.classList.toggle('is-active', isActive);

    if (isActive) {
      button.setAttribute('aria-current', 'page');
    }

    button.addEventListener('click', () => {
      if (isDisabled) {
        return;
      }

      this.currentPage = page;
      this.render();
    });

    return button;
  }
}
